module.exports = __webpack_public_path__ + "static/img/page2-main.805db043.png";